<template>
	<input
		v-if="settings.f == 'D'"
		type="date"
		:value="value"
		@input="$emit('input', $event.target.value)"
		class="form-control"
	/>
	<input
		v-else-if="settings.f == 'N'"
		type="number"
		:value="value"
		@input="$emit('input', $event.target.value)"
		class="form-control"
	/>
	<drop-draw
		v-else-if="settings.f == 'L' && settings.tabela != '\r'"
		cod="value"
		title="label"
		:value="value"
		@input="$emit('input', $event)"
		:asset="getAssets()"
		:radio="settings.v == 'N'"
	/>
	<textarea
		v-else-if="settings.f == 'L' && settings.campo == 200"
		:value="value"
		@input="$emit('input', $event.target.value)"
		class="form-control"
		rows="3"
	></textarea>
	<input
		v-else
		type="text"
		:value="value"
		@input="$emit('input', $event.target.value)"
		class="form-control"
	/>
</template>
<script>
	import dropDraw from 'app/drop-draw';
	export default {
		props: ['value', 'settings'],
		inject: ['assets'],
		components: { dropDraw },
		methods: {
			getAssets() {
				const tab = JSON.parse(
					JSON.stringify(this.settings.tabela).replace('\\r', '')
				);
				if (tab == '') return [];
				return this.assets.vetores[tab] || [];
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdExams/inputSd2000.vue